<template>
    <div class="modal fade" tabindex="-1" :id="id">
        <div class="modal-dialog modal-md">
          <form id="kt_modal_form_project" @submit.prevent="submitForm" class="form mt-5" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('projects.publish_text') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor"/>
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
                    </svg>
                  </span>
                </div>
              </div>
              <div class="modal-body scroll-y" style="max-height: 75vh">
                <div class="row">
                  <div class="mb-5">
                    <div class="d-flex mb-3">
                      <div
                          class="card d-flex gap-3 flex-row align-items-center shadow rounded-2 p-2">
                        <i v-for="(reaction, index) in reactionEnum"
                           @click.prevent="makeReact(reaction.value)"
                           :key="index"
                           class="fa cursor-pointer hovering-zoom"
                           v-html="reaction.value"
                           style="font-size: 1.2rem"
                        ></i>
                      </div>
                    </div>
                    <CKEditor @text="writeText" :content="formData.content" id="comment-editor" ktClass="h-50px" :with-image="false"/>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click.prevent="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="loading"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
</template>

<script setup>

import {computed, defineProps, onMounted, ref, watch} from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import CKEditor from "@/components/CKEditor.vue";

const emits = defineEmits(['callback'])

const props = defineProps({
  taskId: String,
  id: { type: String, required: true }
})

const store = useStore()

const formData = ref({
  content: "",
  task_id: props.taskId
})
const loading = ref(false)

const reactionEnum = computed(() => store.getters['projects/getProjectReactionEnum'])


watch(() => props.taskId, (newVal) => {
  if (newVal) {
    formData.value = {
      content: "",
      task_id: newVal
    }
  }
}, { immediate: true })


function writeText(text) {
  formData.value.content = text
}

function resetForm() {
  formData.value = {
    content: "",
    task_id: props.taskId
  }
}

function closeModal() {
  $('#'+props.id).modal('toggle')
}

function makeReact(content) {
  store.dispatch('comments/createTaskComment', {content, task_id: props.taskId})
      .then(() => {
        closeModal()
        resetForm()
        emits('callback')
      })
      .catch(() => {})
      .finally(() => {})
}

function submitForm() {
  loading.value = true
  store.dispatch('comments/createTaskComment', formData.value)
      .then(() => {
        closeModal()
        resetForm()
        emits('callback')
      })
      .catch()
      .finally(() => loading.value = false)
}

onMounted(() => {
  store.dispatch('projects/loadProjectReactionEnum')
})



</script>
